import { Injectable, inject } from '@angular/core';
import {
  IListado,
  IQueryParam,
  IRegistro,
  ICreateRegistro,
  IUpdateRegistro,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import { HttpApiAdminService } from '../../auxiliares/servicios/http-api.service';

@Injectable({
  providedIn: 'root',
})
export class RegistrosService {
  private http = inject(HttpApiAdminService);
  private helper = inject(HelperService);

  public listar(queryParams?: IQueryParam): Observable<IListado<IRegistro>> {
    const params = this.helper.getQueryParams(queryParams);
    return this.http.get(`/registros`, { params });
  }

  public listarPorId(id: string): Observable<IRegistro> {
    return this.http.get(`/registros/${id}`);
  }

  public crear(dato: ICreateRegistro): Observable<IRegistro> {
    return this.http.post(`/registros`, dato);
  }

  public editar(id: string, dato: IUpdateRegistro): Observable<IRegistro> {
    return this.http.put(`/registros/${id}`, dato);
  }

  public eliminar(id: string): Observable<IRegistro> {
    return this.http.delete(`/registros/${id}`);
  }
}
